import { render, staticRenderFns } from "./GoogleWorkspaceService.vue?vue&type=template&id=29c1ea67&"
import script from "./GoogleWorkspaceService.vue?vue&type=script&lang=js&"
export * from "./GoogleWorkspaceService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports